import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';

const module = angular.module('policy-status-description', []);

interface PolicyStatusDescriptionController extends angular.IStrictController {
    policyInfo: CustomerPolicyInfo;
    statusClass: string;
    statusText: string;
    setPolicyOrPaymentStatus: () => void;
}

type CombinedPolicyStatus = PolicyStatus | 'pending_terminate' | PaymentStatus;

const statusClass: Record<string, string> = {
    active: 'active',
    delayed: 'active',
    pending_active: 'pending-active',
    pending_terminate: 'cancellation-pending',
    terminated: 'cancelled',
    expired: 'expired',
    failed: 'cancelled',
    not_received: 'cancelled',
    not_received_policy_cancelled: 'cancelled',
    due: 'active',
    outstanding: 'cancelled',
    cc_payments_required: 'active'
};

const statusText: Record<string, string> = {
    active: 'Active',
    delayed: 'Active',
    pending_active: 'Pending Activation',
    pending_terminate: 'Cancellation Pending',
    terminated: 'Cancelled',
    expired: 'Expired',
    failed: 'Payment Failed',
    not_received: 'Payment Not Received',
    not_received_policy_cancelled: 'Cancelled',
    due: 'Outstanding Balance',
    outstanding: 'Outstanding Balance - Cancelled'
};

const alertingPaymentStates: Record<string, boolean> = {
    due: true,
    failed: true,
    not_received_policy_cancelled: true,
    not_received: true,
    outstanding: true,
    cancelled: true
};

module.component('policyStatusDescription', {
    template: template,
    bindings: {
        policyInfo: '<'
    },
    controller: function(this: PolicyStatusDescriptionController) {
        const handlePaymentStatusAlerts = (combinedStatus: CombinedPolicyStatus) => {
            if (alertingPaymentStates[this.policyInfo.payment_status]) {
                combinedStatus = this.policyInfo.payment_status;
                if (combinedStatus === 'outstanding') {
                    combinedStatus = 'due'; // to handle back end possibly sending 'outstanding' for active policies
                }
            }
            return combinedStatus;
        };
        const setStatusDescription = () => {
            if (this.policyInfo) {
                let combinedStatus: CombinedPolicyStatus = this.policyInfo.status;

                if (combinedStatus !== 'terminated' && combinedStatus !== 'expired') {
                    if (this.policyInfo.pending_terminate) {
                        combinedStatus = 'pending_terminate';
                    } else {
                        combinedStatus = handlePaymentStatusAlerts(combinedStatus);
                    }
                } else if (this.policyInfo.payment_status === 'outstanding') {
                    combinedStatus = 'outstanding';
                }

                this.statusText = statusText[combinedStatus];
                this.statusClass = statusClass[combinedStatus];
            }
        };
        this.$onInit = () => {
            setStatusDescription();
        };
    }
});

export { module };
